module.exports = __webpack_public_path__ + "img/medbus.7e0a6b52.png";